import React from "react";
import ConsumptionJournal from "@core/components/journal/ConsumptionJournal";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";

const FormPollsJournalSimple: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <ProductHeader productType="form" showAuth={true} />
      <div className="flex flex-1">
        {/* Sidebar auto-suffisante avec son hamburger */}
        <ProductSidebar productType="form" />

        {/* Contenu principal */}
        <div className="flex-1">
          <ConsumptionJournal />
        </div>
      </div>
    </div>
  );
};

export default FormPollsJournalSimple;
